import React from 'react';

export const TopShefBgIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='108'
    height='28'
    viewBox='0 0 108 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={props.className}>
    <path
      d='M0 2C0 0.8954 0.8954 0 2 0H105.14C106.926 0 107.817 2.1634 106.548 3.4207L97.305 12.5793C96.516 13.3618 96.516 14.6382 97.305 15.4207L106.548 24.5793C107.817 25.8366 106.926 28 105.14 28H0V2Z'
      fill='#F01D59'
    />
  </svg>
);

export const TopShefShefHatIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    className={props.className}
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    x='0px'
    y='0px'
    viewBox='0 0 22.1 19.2'>
    <path
      fill='currentColor'
      d='M20.5,5L20.5,5l-0.1-0.2c-0.9-1.2-2.2-2-3.7-2.1c-0.2,0-0.5,0-0.7,0c-0.2,0-0.4,0-0.7,0
	c-1.1-1.5-2.9-2.3-4.7-2.3c-2.2,0-4.3,1.3-5.3,3.3c0,0-0.1,0-0.1,0c-0.9,0-1.8,0.3-2.6,0.8C1.6,5.1,0.9,6.2,0.6,7.5
	c-0.3,1.3,0,2.6,0.7,3.7c0.7,1.1,1.8,1.9,3,2.2c0.1,0,0.2,0,0.2,0c0.5,0,1-0.4,1.1-0.9c0.1-0.6-0.2-1.2-0.8-1.3
	C4.1,11,3.5,10.6,3.1,10C2.8,9.4,2.6,8.7,2.8,8c0.1-0.7,0.6-1.3,1.1-1.7C4.2,6.2,4.5,6,4.8,6c0,0.1,0,0.3,0,0.4
	c0,0.6,0.5,1.1,1.1,1.1S7,7,7,6.4c0-2.1,1.7-3.8,3.7-3.8c0.9,0,1.7,0.3,2.4,0.9c-0.2,0.1-0.3,0.2-0.5,0.3c-0.5,0.4-0.6,1.1-0.2,1.6
	c0.2,0.3,0.5,0.4,0.9,0.4c0.3,0,0.5-0.1,0.7-0.2c0.6-0.5,1.3-0.7,2-0.7c0.1,0,0.3,0,0.4,0c0.9,0.1,1.7,0.6,2.2,1.3
	c1.1,1.4,0.9,3.5-0.4,4.7c-1.4-0.6-2.6-0.8-4.1-0.8c-0.5,0-1.1,0-1.9,0.1c-0.6,0.1-1.1,0.6-1,1.2c0.1,0.6,0.5,1,1.1,1
	c0,0,0.1,0,0.1,0c0.7-0.1,1.2-0.1,1.7-0.1c1.1,0,2,0.2,3,0.6l-0.4,3.3c-1.7-0.6-3.6-0.9-5.5-0.9c-1.9,0-3.8,0.3-5.5,0.9
	C5.2,16.3,4.9,17,5,17.6c0.2,0.5,0.6,0.8,1.1,0.8c0.1,0,0.2,0,0.3-0.1c1.5-0.5,3.1-0.8,4.8-0.8c2,0,4.2,0.4,5.9,1.2
	c0.1,0.1,0.3,0.1,0.4,0.1c0.2,0,0.4-0.1,0.5-0.1c0.3-0.2,0.5-0.5,0.6-0.8l0.7-5.1c0,0,0,0,0,0C21.8,10.9,22.3,7.4,20.5,5z'
    />
  </svg>
);
